// src/localeAffichage.ts
var DEFAULT_LOCALE = "fr-FR";
var etatLocale = globalThis[Symbol.for("donoor.utils.locale")] ??= { courante: DEFAULT_LOCALE, fournisseur: null };
function localeAffichage() {
  return etatLocale.fournisseur?.() ?? etatLocale.courante;
}

// src/i18nMots.ts
var LANGUES_SUPPORTEES = ["fr", "en", "de", "es", "it", "nl"];
function langueDepuisLocale(locale) {
  const code = (locale ?? "").slice(0, 2).toLowerCase();
  return LANGUES_SUPPORTEES.includes(code) ? code : "fr";
}
var LOCALE_INTL_PAR_LANGUE = {
  fr: "fr-FR",
  en: "en-GB",
  de: "de-DE",
  es: "es-ES",
  it: "it-IT",
  nl: "nl-NL"
};
function plFr(n, singulier, pluriel) {
  return Math.abs(n) < 2 ? singulier : pluriel;
}
function plStd(n, singulier, pluriel) {
  return n === 1 ? singulier : pluriel;
}
var MOTS_RELATIFS = {
  fr: {
    aLInstant: "\xC0 l'instant",
    ilYAMinute: (n) => `Il y a ${n} ${plFr(n, "minute", "minutes")}`,
    ilYAHeure: (n) => `Il y a ${n} ${plFr(n, "heure", "heures")}`,
    ilYAJour: (n) => `Il y a ${n} ${plFr(n, "jour", "jours")}`,
    ilYASemaine: (n) => `Il y a ${n} ${plFr(n, "semaine", "semaines")}`,
    ilYAMois: (n) => `Il y a ${n} mois`,
    ilYAAn: (n) => `Il y a ${n} ${plFr(n, "an", "ans")}`,
    ilYAMinuteCompact: (n) => `Il y a ${n} min`,
    ilYAHeureCompact: (n) => `Il y a ${n}h`,
    ilYAJourCompact: (n) => `Il y a ${n}j`,
    ilYASemaineCompact: (n) => `Il y a ${n} sem.`,
    ilYAMoisCompact: (n) => `Il y a ${n} mois`,
    ilYAAnCompact: (n) => `Il y a ${n} ${plFr(n, "an", "ans")}`,
    hierA: (h) => `Hier \xE0 ${h}`,
    avantHierA: (h) => `Avant-hier \xE0 ${h}`,
    aujourdhuiAbrege: (h) => `aujd ${h}`,
    hierAbrege: (h) => `hier ${h}`,
    dateEtHeure: (date, h) => `${date} \xE0 ${h}`
  },
  en: {
    aLInstant: "Just now",
    ilYAMinute: (n) => `${n} ${plStd(n, "minute", "minutes")} ago`,
    ilYAHeure: (n) => `${n} ${plStd(n, "hour", "hours")} ago`,
    ilYAJour: (n) => `${n} ${plStd(n, "day", "days")} ago`,
    ilYASemaine: (n) => `${n} ${plStd(n, "week", "weeks")} ago`,
    ilYAMois: (n) => `${n} ${plStd(n, "month", "months")} ago`,
    ilYAAn: (n) => `${n} ${plStd(n, "year", "years")} ago`,
    ilYAMinuteCompact: (n) => `${n} min ago`,
    ilYAHeureCompact: (n) => `${n}h ago`,
    ilYAJourCompact: (n) => `${n}d ago`,
    ilYASemaineCompact: (n) => `${n} wk ago`,
    ilYAMoisCompact: (n) => `${n} mo ago`,
    ilYAAnCompact: (n) => `${n}y ago`,
    hierA: (h) => `Yesterday at ${h}`,
    avantHierA: (h) => `The day before yesterday at ${h}`,
    aujourdhuiAbrege: (h) => `today ${h}`,
    hierAbrege: (h) => `yesterday ${h}`,
    dateEtHeure: (date, h) => `${date} at ${h}`
  },
  de: {
    aLInstant: "Gerade eben",
    // "vor" régit le datif : Minuten/Stunden/Tagen/Wochen/Monaten/Jahren au pluriel.
    ilYAMinute: (n) => `Vor ${n} ${plStd(n, "Minute", "Minuten")}`,
    ilYAHeure: (n) => `Vor ${n} ${plStd(n, "Stunde", "Stunden")}`,
    ilYAJour: (n) => `Vor ${n} ${plStd(n, "Tag", "Tagen")}`,
    ilYASemaine: (n) => `Vor ${n} ${plStd(n, "Woche", "Wochen")}`,
    ilYAMois: (n) => `Vor ${n} ${plStd(n, "Monat", "Monaten")}`,
    ilYAAn: (n) => `Vor ${n} ${plStd(n, "Jahr", "Jahren")}`,
    ilYAMinuteCompact: (n) => `Vor ${n} Min.`,
    ilYAHeureCompact: (n) => `Vor ${n} Std.`,
    ilYAJourCompact: (n) => `Vor ${n} T.`,
    ilYASemaineCompact: (n) => `Vor ${n} Wo.`,
    ilYAMoisCompact: (n) => `Vor ${n} Mon.`,
    ilYAAnCompact: (n) => `Vor ${n} J.`,
    hierA: (h) => `Gestern um ${h}`,
    avantHierA: (h) => `Vorgestern um ${h}`,
    aujourdhuiAbrege: (h) => `heute ${h}`,
    hierAbrege: (h) => `gestern ${h}`,
    dateEtHeure: (date, h) => `${date} um ${h}`
  },
  es: {
    aLInstant: "Ahora mismo",
    ilYAMinute: (n) => `Hace ${n} ${plStd(n, "minuto", "minutos")}`,
    ilYAHeure: (n) => `Hace ${n} ${plStd(n, "hora", "horas")}`,
    ilYAJour: (n) => `Hace ${n} ${plStd(n, "d\xEDa", "d\xEDas")}`,
    ilYASemaine: (n) => `Hace ${n} ${plStd(n, "semana", "semanas")}`,
    ilYAMois: (n) => `Hace ${n} ${plStd(n, "mes", "meses")}`,
    ilYAAn: (n) => `Hace ${n} ${plStd(n, "a\xF1o", "a\xF1os")}`,
    ilYAMinuteCompact: (n) => `Hace ${n} min`,
    ilYAHeureCompact: (n) => `Hace ${n} h`,
    ilYAJourCompact: (n) => `Hace ${n} d`,
    ilYASemaineCompact: (n) => `Hace ${n} sem.`,
    ilYAMoisCompact: (n) => `Hace ${n} ${plStd(n, "mes", "meses")}`,
    ilYAAnCompact: (n) => `Hace ${n} ${plStd(n, "a\xF1o", "a\xF1os")}`,
    hierA: (h) => `Ayer a las ${h}`,
    avantHierA: (h) => `Anteayer a las ${h}`,
    aujourdhuiAbrege: (h) => `hoy ${h}`,
    hierAbrege: (h) => `ayer ${h}`,
    dateEtHeure: (date, h) => `${date} a las ${h}`
  },
  it: {
    aLInstant: "Proprio ora",
    ilYAMinute: (n) => `${n} ${plStd(n, "minuto", "minuti")} fa`,
    ilYAHeure: (n) => `${n} ${plStd(n, "ora", "ore")} fa`,
    ilYAJour: (n) => `${n} ${plStd(n, "giorno", "giorni")} fa`,
    ilYASemaine: (n) => `${n} ${plStd(n, "settimana", "settimane")} fa`,
    ilYAMois: (n) => `${n} ${plStd(n, "mese", "mesi")} fa`,
    ilYAAn: (n) => `${n} ${plStd(n, "anno", "anni")} fa`,
    ilYAMinuteCompact: (n) => `${n} min fa`,
    ilYAHeureCompact: (n) => `${n} h fa`,
    ilYAJourCompact: (n) => `${n}g fa`,
    ilYASemaineCompact: (n) => `${n} sett. fa`,
    ilYAMoisCompact: (n) => `${n} ${plStd(n, "mese", "mesi")} fa`,
    ilYAAnCompact: (n) => `${n} ${plStd(n, "anno", "anni")} fa`,
    hierA: (h) => `Ieri alle ${h}`,
    avantHierA: (h) => `L'altro ieri alle ${h}`,
    aujourdhuiAbrege: (h) => `oggi ${h}`,
    hierAbrege: (h) => `ieri ${h}`,
    dateEtHeure: (date, h) => `${date} alle ${h}`
  },
  nl: {
    aLInstant: "Zojuist",
    ilYAMinute: (n) => `${n} ${plStd(n, "minuut", "minuten")} geleden`,
    ilYAHeure: (n) => `${n} uur geleden`,
    // "uur" invariable au pluriel.
    ilYAJour: (n) => `${n} ${plStd(n, "dag", "dagen")} geleden`,
    ilYASemaine: (n) => `${n} ${plStd(n, "week", "weken")} geleden`,
    ilYAMois: (n) => `${n} ${plStd(n, "maand", "maanden")} geleden`,
    ilYAAn: (n) => `${n} jaar geleden`,
    // "jaar" invariable au pluriel.
    ilYAMinuteCompact: (n) => `${n} min geleden`,
    ilYAHeureCompact: (n) => `${n} u geleden`,
    ilYAJourCompact: (n) => `${n} d geleden`,
    ilYASemaineCompact: (n) => `${n} wk geleden`,
    ilYAMoisCompact: (n) => `${n} mnd geleden`,
    ilYAAnCompact: (n) => `${n} jr geleden`,
    hierA: (h) => `Gisteren om ${h}`,
    avantHierA: (h) => `Eergisteren om ${h}`,
    aujourdhuiAbrege: (h) => `vandaag ${h}`,
    hierAbrege: (h) => `gisteren ${h}`,
    dateEtHeure: (date, h) => `${date} om ${h}`
  }
};

// src/dates.ts
var ORG_TIMEZONE = "Europe/Paris";
var PARTS_FORMATTERS = /* @__PURE__ */ new Map();
function formatterParties(fuseau) {
  let f = PARTS_FORMATTERS.get(fuseau);
  if (!f) {
    f = new Intl.DateTimeFormat("en-US", {
      timeZone: fuseau,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    PARTS_FORMATTERS.set(fuseau, f);
  }
  return f;
}
function partsInZone(date, fuseau = ORG_TIMEZONE) {
  const map = {};
  for (const p of formatterParties(fuseau).formatToParts(date)) {
    if (p.type !== "literal") map[p.type] = p.value;
  }
  return {
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
    hour: Number(map.hour),
    minute: Number(map.minute),
    second: Number(map.second)
  };
}
function zoneOffsetMinutes(date, fuseau = ORG_TIMEZONE) {
  const p = partsInZone(date, fuseau);
  const asUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
  return Math.round((asUtc - date.getTime()) / 6e4);
}
function zonedWallTimeToUtc(year, month, day, hour, minute, second, ms, fuseau = ORG_TIMEZONE) {
  const naiveUtc = Date.UTC(year, month - 1, day, hour, minute, second, ms);
  let offset = zoneOffsetMinutes(new Date(naiveUtc), fuseau);
  let candidate = naiveUtc - offset * 6e4;
  const offset2 = zoneOffsetMinutes(new Date(candidate), fuseau);
  if (offset2 !== offset) {
    offset = offset2;
    candidate = naiveUtc - offset * 6e4;
  }
  return new Date(candidate);
}
function parisDayStartToUtc(year, month, day, fuseau = ORG_TIMEZONE) {
  return zonedWallTimeToUtc(year, month, day, 0, 0, 0, 0, fuseau);
}
function parisDayEndToUtc(year, month, day, fuseau = ORG_TIMEZONE) {
  return zonedWallTimeToUtc(year, month, day, 23, 59, 59, 999, fuseau);
}
function instantDepuisHeureLocale(jour, heure = "00:00", fuseau = ORG_TIMEZONE) {
  const [y, m, d] = jour.split("-").map(Number);
  const [h, min] = heure.split(":").map(Number);
  return zonedWallTimeToUtc(y, m, d, h ?? 0, min ?? 0, 0, 0, fuseau);
}
function heureLocaleDepuisInstant(date, fuseau = ORG_TIMEZONE) {
  const p = partsInZone(parseDbInstant(date), fuseau);
  const pad = (n) => String(n).padStart(2, "0");
  return { jour: `${p.year}-${pad(p.month)}-${pad(p.day)}`, heure: `${pad(p.hour)}:${pad(p.minute)}` };
}
function toDayKey(date, fuseau = ORG_TIMEZONE) {
  const d = parseDbInstant(date);
  const p = partsInZone(d, fuseau);
  const mm = String(p.month).padStart(2, "0");
  const dd = String(p.day).padStart(2, "0");
  return `${p.year}-${mm}-${dd}`;
}
function toDayBounds(date, fuseau = ORG_TIMEZONE) {
  const d = parseDbInstant(date);
  const p = partsInZone(d, fuseau);
  return {
    from: parisDayStartToUtc(p.year, p.month, p.day, fuseau).toISOString(),
    to: parisDayEndToUtc(p.year, p.month, p.day, fuseau).toISOString()
  };
}
function periodBounds(period, ref = /* @__PURE__ */ new Date(), fuseau = ORG_TIMEZONE) {
  const refDate = typeof ref === "string" ? new Date(ref) : ref;
  const { year, month, day } = partsInZone(refDate, fuseau);
  switch (period) {
    case "day":
      return {
        from: parisDayStartToUtc(year, month, day, fuseau).toISOString(),
        to: parisDayEndToUtc(year, month, day, fuseau).toISOString()
      };
    case "week": {
      const dow = parisWeekdayMondayZero(year, month, day);
      const monday = addParisDays(year, month, day, -dow);
      const sunday = addParisDays(monday.year, monday.month, monday.day, 6);
      return {
        from: parisDayStartToUtc(monday.year, monday.month, monday.day, fuseau).toISOString(),
        to: parisDayEndToUtc(sunday.year, sunday.month, sunday.day, fuseau).toISOString()
      };
    }
    case "month": {
      const lastDay = daysInMonth(year, month);
      return {
        from: parisDayStartToUtc(year, month, 1, fuseau).toISOString(),
        to: parisDayEndToUtc(year, month, lastDay, fuseau).toISOString()
      };
    }
    case "quarter": {
      const qStartMonth = Math.floor((month - 1) / 3) * 3 + 1;
      const qEndMonth = qStartMonth + 2;
      const lastDay = daysInMonth(year, qEndMonth);
      return {
        from: parisDayStartToUtc(year, qStartMonth, 1, fuseau).toISOString(),
        to: parisDayEndToUtc(year, qEndMonth, lastDay, fuseau).toISOString()
      };
    }
    case "year":
      return {
        from: parisDayStartToUtc(year, 1, 1, fuseau).toISOString(),
        to: parisDayEndToUtc(year, 12, 31, fuseau).toISOString()
      };
    default: {
      throw new Error(`Unknown period: ${String(period)}`);
    }
  }
}
function hasExplicitTimezone(value) {
  if (!value.includes("T") && !value.includes(" ")) return true;
  if (/[zZ]$/.test(value)) return true;
  return /\d{2}:\d{2}(:\d{2})?(\.\d+)?\s*[+-]\d{2}(:?\d{2})?$/.test(value);
}
function parseDbInstant(date) {
  if (typeof date !== "string") return date;
  const trimmed = date.trim();
  if (!hasExplicitTimezone(trimmed)) {
    return /* @__PURE__ */ new Date(trimmed.replace(" ", "T") + "Z");
  }
  return new Date(trimmed);
}
function formatInParis(date, opts = {}, locale = localeAffichage(), fuseau = ORG_TIMEZONE) {
  const d = parseDbInstant(date);
  return new Intl.DateTimeFormat(locale, {
    ...opts,
    timeZone: fuseau
  }).format(d);
}
function formatInZone(date, fuseau, opts = {}, locale = localeAffichage()) {
  return formatInParis(date, opts, locale, fuseau || ORG_TIMEZONE);
}
function formatDateTimeInParis(date, fuseau = ORG_TIMEZONE) {
  if (!date) return "\u2014";
  const d = parseDbInstant(date);
  if (Number.isNaN(d.getTime())) return "\u2014";
  const parts = new Intl.DateTimeFormat("fr-FR", {
    timeZone: fuseau,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).formatToParts(d);
  const get = (type) => parts.find((p) => p.type === type)?.value ?? "";
  return `${get("day")}/${get("month")}/${get("year")} ${get("hour")}:${get("minute")}`;
}
function formatDateAHeureInParis(date, fuseau = ORG_TIMEZONE) {
  const s = formatDateTimeInParis(date, fuseau);
  return s === "\u2014" ? s : s.replace(" ", " \xE0 ");
}
function daysInMonth(year, month) {
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
function parisWeekdayMondayZero(year, month, day) {
  const dow = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return (dow + 6) % 7;
}
function addParisDays(year, month, day, delta) {
  const d = new Date(Date.UTC(year, month - 1, day + delta));
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate()
  };
}
function formatSmartDateTimeInParis(date, now = /* @__PURE__ */ new Date(), fuseau = ORG_TIMEZONE, langue = langueDepuisLocale(localeAffichage())) {
  if (!date) return "\u2014";
  const d = parseDbInstant(date);
  if (Number.isNaN(d.getTime())) return "\u2014";
  const mots = MOTS_RELATIFS[langue];
  const time = new Intl.DateTimeFormat("fr-FR", {
    timeZone: fuseau,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(d);
  const key = toDayKey(d, fuseau);
  if (key === toDayKey(now, fuseau)) return time;
  if (key === toDayKey(new Date(now.getTime() - 864e5), fuseau)) {
    return mots.hierA(time);
  }
  if (key === toDayKey(new Date(now.getTime() - 2 * 864e5), fuseau)) {
    return mots.avantHierA(time);
  }
  const [year = "", month = "", day = ""] = key.split("-");
  return mots.dateEtHeure(`${day}/${month}/${year}`, time);
}
function formatSmartDateTimeNumeriqueInParis(date, now = /* @__PURE__ */ new Date(), fuseau = ORG_TIMEZONE, langue = langueDepuisLocale(localeAffichage())) {
  if (!date) return "\u2014";
  const d = parseDbInstant(date);
  if (Number.isNaN(d.getTime())) return "\u2014";
  const mots = MOTS_RELATIFS[langue];
  const time = new Intl.DateTimeFormat("fr-FR", {
    timeZone: fuseau,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(d);
  const key = toDayKey(d, fuseau);
  if (key === toDayKey(now, fuseau)) return time;
  if (key === toDayKey(new Date(now.getTime() - 864e5), fuseau)) {
    return mots.hierA(time);
  }
  const [year = "", month = "", day = ""] = key.split("-");
  return mots.dateEtHeure(`${day}/${month}/${year}`, time);
}
function formatLastAccessInParis(date, now = /* @__PURE__ */ new Date(), fuseau = ORG_TIMEZONE, langue = langueDepuisLocale(localeAffichage())) {
  if (!date) return "\u2014";
  const d = parseDbInstant(date);
  if (Number.isNaN(d.getTime())) return "\u2014";
  const mots = MOTS_RELATIFS[langue];
  const time = new Intl.DateTimeFormat("fr-FR", {
    timeZone: fuseau,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(d).replace(":", "h");
  const key = toDayKey(d, fuseau);
  if (key === toDayKey(now, fuseau)) return mots.aujourdhuiAbrege(time);
  if (key === toDayKey(new Date(now.getTime() - 864e5), fuseau)) {
    return mots.hierAbrege(time);
  }
  const day = new Intl.DateTimeFormat(LOCALE_INTL_PAR_LANGUE[langue], {
    timeZone: fuseau,
    day: "2-digit",
    month: "short"
  }).format(d);
  return mots.dateEtHeure(day, time);
}
function isMultiDayEvent(startDate, endDate) {
  if (!startDate || !endDate) return false;
  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();
  const DAY_MS = 24 * 60 * 60 * 1e3;
  return Number.isFinite(start) && Number.isFinite(end) && end - start >= DAY_MS;
}

export { ORG_TIMEZONE, formatDateAHeureInParis, formatDateTimeInParis, formatInParis, formatInZone, formatLastAccessInParis, formatSmartDateTimeInParis, formatSmartDateTimeNumeriqueInParis, heureLocaleDepuisInstant, instantDepuisHeureLocale, isMultiDayEvent, parseDbInstant, periodBounds, toDayBounds, toDayKey };
//# sourceMappingURL=dates.js.map
//# sourceMappingURL=dates.js.map